import React, { useContext } from 'react';
import { createContext } from 'react';

import { User } from '../utils/backend-api/currentUser';

export type Env = {
  READ_ONLY_MODE?: boolean;
  READ_ONLY_PHRASE?: string;
};

type AppContextType = {
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
};

const AppContext = createContext<AppContextType>({
  env: {},
  isWebview: false,
});

export const AppContextProvider = ({
  env,
  initialCurrentUser,
  isWebview = false,
  children,
}: {
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
  children: React.ReactNode;
}) => {
  const value = { env, initialCurrentUser, isWebview };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  return context;
};
